import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Title = styled.div`
  font-weight: 700;
  color: #213f68;
  word-break: break-word;
`

export const Tags = styled.div<{ correct: boolean }>`
  span {
    border: 1px solid #d9d9d9;
    background: #f5f5f5;
    border-radius: 8px;
    padding: 4px;
    color: #363636;
    font-size: 12px;
    white-space: nowrap;
    margin-left: 16px;
  }
  span + span {
    ${({ correct }) =>
      correct
        ? css`
            border: 1px solid #88e3bc;
            background: #d7f5e9;
          `
        : css`
            border: 1px solid #f7a2a2;
            background: #fde0e0;
          `}
  }
`
